import Vue from 'vue';
import MessageAlert from '@/components/MessageAlert.vue';

export default function message(options = {}) {
  const { title = '提示', message = '操作失败', type = 'notification', effect = 'success', onClose, onCancel } = options;
  const AlertConstructor = Vue.extend(MessageAlert);
  const instance = new AlertConstructor({
    propsData: {
      show: true,
      type,
      effect,
      title,
      message
    }
  });
  instance.$on('close', () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  });
  instance.$on('cancel', () => {
    if (typeof onCancel === 'function') {
      onCancel();
    }
  });
  instance.$mount();
  document.body.appendChild(instance.$el);
  return instance;
}
